import { environment as baseEnv } from './environment-base';

export const environment = { ...baseEnv, production: false };
